(function () {
  var LOGO_OVERRIDES = {
    Mytee: 'brand-logo-mytee.png',
    CleanFreak: 'brand-logo-cleanfreak.png',
    'Trusted Clean': 'brand-logo-trusted-clean.png',
    Sandia: 'brand-logo-sandia.png',
    Advance: 'brand-logo-advance.png',
    Clarke: 'brand-logo-clarke.png',
    'IPC Eagle': 'brand-logo-ipc-eagle.png',
    Tornado: 'brand-logo-tornado.png',
    'Powr-Flite': 'brand-logo-powr-flite.png',
    'Pacific Floorcare': 'brand-logo-pacific-floorcare.png',
    Minuteman: 'brand-logo-minuteman.png',
    Hawk: 'brand-logo-hawk.png',
    Tennant: 'brand-logo-tennant.png',
    Viper: 'brand-logo-viper.png',
    Malish: 'brand-logo-malish.png',
    'Square Scrub': 'brand-logo-square-scrub.png',
    MotorScrubber: 'brand-logo-motorscrubber.png',
    Aztec: 'brand-logo-aztec.png',
    EDIC: 'brand-logo-edic.png',
    Aaladin: 'brand-logo-aaladin.png',
    Koblenz: 'brand-logo-koblenz.png',
    ProTeam: 'brand-logo-proteam.png',
    Hoover: 'brand-logo-hoover.png',
    Bissell: 'brand-logo-bissell.png',
    Oreck: 'brand-logo-oreck.png',
    Nilfisk: 'brand-logo-nilfisk.png',
    'Nilfisk Advance': 'brand-logo-nilfisk-advance.png',
    SUNMAX: 'brand-logo-sunmax.png',
    'Tomcat Factory Cat': 'brand-logo-tomcat-factory-cat.png',
    'The Cleaning Business': 'brand-logo-tcb.png',
    'TCB Equipment': 'brand-logo-tcb-equipment.png',
    'Libman Commercial': 'brand-logo-libman-commercial.png',
    'Super Lube': 'brand-logo-super-lube.png',
    Sanitaire: 'brand-logo-sanitaire.png',
    Royal: 'brand-logo-royal.png',
    'Dri-Eaz': 'brand-logo-dri-eaz.png',
    EvaClean: 'brand-logo-evaclean.png',
    Xpower: 'brand-logo-xpower.png',
    Hotsy: 'brand-logo-hotsy.png',
    Landa: 'brand-logo-landa.png',
    'Kärcher': 'brand-logo-karcher.png',
    'KÃ¤rcher': 'brand-logo-karcher.png',
    'Bright Solutions': 'brand-logo-bright-solutions.png',
    '3M': 'brand-logo-3m.png',
    Clorox: 'brand-logo-clorox.png',
    Nyco: 'brand-logo-nyco.png',
    Diversey: 'brand-logo-diversey.png',
    Rubbermaid: 'brand-logo-rubbermaid.png',
    "O'Cedar": 'brand-logo-ocedar.png',
    Zep: 'brand-logo-zep.png',
    GOJO: 'brand-logo-gojo.png',
    DeWalt: 'brand-logo-dewalt.png',
    Betco: 'brand-logo-betco.png',
    Diamabrush: 'brand-logo-diamabrush.png',
    Ettore: 'brand-logo-ettore.png',
    Flex: 'brand-logo-flex.png',
    Kaivac: 'brand-logo-kaivac.png',
    'Koch-Chemie': 'brand-logo-koch-chemie.png',
    'Lake Country': 'brand-logo-lake-country.png',
    Mercury: 'brand-logo-mercury.png',
    'Metro Vac': 'brand-logo-metro-vac.png',
    NSS: 'brand-logo-nss.png',
    'Pressure-Pro': 'brand-logo-pressure-pro.png',
    Pumptec: 'brand-logo-pumptec.png',
    Rupes: 'brand-logo-rupes.png',
    'Simple Green': 'brand-logo-simple-green.png',
    SONAX: 'brand-logo-sonax.png',
    Thermax: 'brand-logo-thermax.png',
    Tornador: 'brand-logo-tornador.png',
    Unger: 'brand-logo-unger.png',
    Vapamore: 'brand-logo-vapamore.png',
    Windsor: 'brand-logo-windsor.png',
    Nobles: 'brand-logo-nobles.png',
    Comet: 'brand-logo-comet.png',
    Stinger: 'brand-logo-stinger.png',
    Supernova: 'brand-logo-supernova.png',
    'Perfect Aire': 'brand-logo-perfect-aire.png',
    Mastercraft: 'brand-logo-mastercraft.png',
    'Cam Spray': 'brand-logo-cam-spray.png',
    Atrix: 'brand-logo-atrix.png',
    'Mor-Medical International': 'brand-logo-mor-medical-international.png',
    UnoClean: 'brand-logo-unoclean.png',
    'Legacy Flexzilla': 'brand-logo-legacy-flexzilla.png',
    'Libman Commercial': 'brand-logo-libman-commercial.png',
    'Super Lube': 'brand-logo-super-lube.png',
    'Hoover Commercial': 'brand-logo-hoover-commercial.png',
    'Atrix - Vacuums': 'brand-logo-atrix.png',
    'Cam Spray - Parts': 'brand-logo-cam-spray.png',
    'Cam Spray - Pressure Washers': 'brand-logo-cam-spray.png',
    'UnoClean Professional Cleaning Equipment': 'brand-logo-unoclean.png',
    'MasterCraft - Parts/Acc.': 'brand-logo-mastercraft.png',
    'Bissell Cleaning Products': 'brand-logo-bissell.png',
    'Sandia Products': 'brand-logo-sandia.png',
    'Mor-Medical International': 'brand-logo-mor-medical-international.png'
  };

  var VENDOR_URL_OVERRIDES = {
    sunmax: '/products/rt50-lithium-floor-scrubber-22-inch',
    sandia: '/collections/carpet-extractors',
    cleanfreak: '/search?type=product&q=vendor%3ACleanFreak',
    'trusted-clean': '/search?type=product&q=vendor%3ATrusted%20Clean',
    'tcb-supplies': '/collections/the-cleaning-business',
    'tcb-equipment': '/collections/the-cleaning-business',
    'the-cleaning-business': '/collections/the-cleaning-business',
    'tomcat-factory-cat': '/collections/tomcat-factory-cat-parts',
    tennant: '/collections/shop-all-parts',
    'nilfisk-advance': '/collections/shop-all-parts',
    clarke: '/collections/shop-all-parts',
    viper: '/collections/shop-all-parts',
    nobles: '/collections/shop-all-parts',
    'karcher-windsor': '/collections/shop-all-parts',
    nss: '/collections/shop-all-parts',
    'ipc-eagle': '/collections/shop-all-parts',
    advance: '/collections/shop-all-parts'
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function slugify(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function vendorUrl(brand) {
    if (brand.url) return brand.url;
    var handle = brand.id || slugify(brand.name);
    if (VENDOR_URL_OVERRIDES[handle]) return VENDOR_URL_OVERRIDES[handle];
    return '/search?type=product&q=' + encodeURIComponent('vendor:' + brand.name);
  }

  function logoAsset(brand) {
    if (LOGO_OVERRIDES[brand.name]) return LOGO_OVERRIDES[brand.name];
    if (brand.id) return 'brand-logo-' + brand.id + '.png';
    return 'brand-logo-' + slugify(brand.name) + '.png';
  }

  function letterRange(letter) {
    if (!letter || letter < 'A' || letter > 'Z') return 'a-f';
    var code = letter.charCodeAt(0);
    if (code <= 70) return 'a-f';
    if (code <= 76) return 'g-l';
    if (code <= 82) return 'm-r';
    return 's-z';
  }

  function buildLogoMarkup(brand, assetRoot) {
    var asset = logoAsset(brand);
    var src = assetRoot + asset;
    return (
      '<div class="tcb-brands-logo-wrap tcb-brands-logo-wrap--card">' +
      '<img class="tcb-brands-logo-img" src="' +
      escapeHtml(src) +
      '" alt="' +
      escapeHtml(brand.name) +
      '" loading="lazy" decoding="async" width="180" height="72" onerror="this.outerHTML=\'<span class=&quot;tcb-brands-logo-fallback&quot;>\'+this.alt+\'</span>\'">' +
      '</div>'
    );
  }

  function buildBrandCard(brand, assetRoot) {
    var name = brand.name || '';
    var letter = name.charAt(0).toUpperCase();
    var featured = !!brand.featured;
    var tagline = brand.tagline || '';
    var html =
      '<a href="' +
      escapeHtml(vendorUrl(brand)) +
      '" class="tcb-brands-tile" data-tcb-brand-card data-name="' +
      escapeHtml(name) +
      '" data-letter="' +
      escapeHtml(letter) +
      '" data-featured="' +
      featured +
      '">';
    html += '<div class="tcb-brands-tile__logo">' + buildLogoMarkup(brand, assetRoot) + '</div>';
    if (featured) html += '<span class="tcb-brands-tile__badge">Partner</span>';
    html += '<h3 class="tcb-brands-tile__name">' + escapeHtml(name) + '</h3>';
    if (tagline) html += '<p class="tcb-brands-tile__tagline">' + escapeHtml(tagline) + '</p>';
    html += '<span class="tcb-brands-tile__link">View products →</span></a>';
    return html;
  }

  function initSection(section) {
    var root = section.querySelector('[data-tcb-brands-root]');
    if (!root) return;

    var perPage = parseInt(section.getAttribute('data-per-page') || '24', 10);
    var catalogUrl = section.getAttribute('data-catalog-url');
    var grid = root.querySelector('[data-tcb-brands-grid]');
    var loadingEl = root.querySelector('[data-tcb-brands-loading]');
    var countEl = root.querySelector('[data-tcb-brands-count]');
    var emptyEl = root.querySelector('[data-tcb-brands-empty]');
    var loadWrap = section.querySelector('[data-tcb-load-more-wrap]');
    var loadBtn = section.querySelector('[data-tcb-load-more]');
    var sortSelect = root.querySelector('[data-tcb-brands-sort]');
    var letterBtns = root.querySelectorAll('[data-tcb-letter-filter]');
    var scrollGrid = section.querySelector('[data-tcb-scroll-grid]');
    var popularWrap = section.querySelector('[data-tcb-popular-wrap]');
    var popularList = section.querySelector('[data-tcb-popular-list]');

    var cards = [];
    var state = {
      letter: 'all',
      sort: 'az',
      page: 1
    };

    function bindInteractions() {
      cards = Array.prototype.slice.call(root.querySelectorAll('[data-tcb-brand-card]'));

      cards.forEach(function (card) {
        var letter = (card.getAttribute('data-letter') || '').toUpperCase();
        card.setAttribute('data-range', letterRange(letter));
      });

      sortCards();
      updateView();
    }

    function sortCards() {
      var sorted = cards.slice().sort(function (a, b) {
        var fa = a.getAttribute('data-featured') === 'true';
        var fb = b.getAttribute('data-featured') === 'true';
        var na = (a.getAttribute('data-name') || '').toLowerCase();
        var nb = (b.getAttribute('data-name') || '').toLowerCase();

        if (state.sort === 'featured') {
          if (fa !== fb) return fa ? -1 : 1;
          return na.localeCompare(nb);
        }
        if (state.sort === 'za') return nb.localeCompare(na);
        return na.localeCompare(nb);
      });

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function filteredCards() {
      return cards.filter(function (card) {
        if (state.letter === 'all') return true;
        return card.getAttribute('data-range') === state.letter;
      });
    }

    function updateView() {
      var visibleSet = filteredCards();
      var total = visibleSet.length;
      var showCount = Math.min(state.page * perPage, total);
      var shown = 0;

      cards.forEach(function (card) {
        card.hidden = true;
        card.classList.remove('is-visible');
      });

      visibleSet.forEach(function (card, index) {
        if (index < showCount) {
          card.hidden = false;
          card.classList.add('is-visible');
          shown += 1;
        }
      });

      if (countEl) {
        if (total === 0) {
          countEl.textContent = 'No brands found';
        } else if (total <= perPage) {
          countEl.textContent = 'Showing all ' + total + ' brands';
        } else {
          countEl.textContent = 'Showing 1–' + shown + ' of ' + total + ' brands';
        }
      }

      if (emptyEl) emptyEl.hidden = total > 0;
      if (loadWrap) loadWrap.hidden = shown >= total;
    }

    letterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.letter = btn.getAttribute('data-tcb-letter-filter');
        state.page = 1;
        letterBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateView();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        sortCards();
        updateView();
      });
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        state.page += 1;
        updateView();
      });
    }

    function showAllBrands() {
      state.letter = 'all';
      state.page = Math.max(1, Math.ceil(cards.length / perPage));
      letterBtns.forEach(function (b) {
        var isAll = b.getAttribute('data-tcb-letter-filter') === 'all';
        b.classList.toggle('is-active', isAll);
        b.setAttribute('aria-pressed', isAll ? 'true' : 'false');
      });
      updateView();
    }

    if (scrollGrid) {
      scrollGrid.addEventListener('click', function (e) {
        e.preventDefault();
        showAllBrands();
        var target = section.querySelector('#tcb-brands-grid');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (!catalogUrl || !grid) {
      if (loadingEl) loadingEl.textContent = 'Unable to load brands.';
      return;
    }

    fetch(catalogUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Catalog fetch failed');
        return response.json();
      })
      .then(function (brands) {
        var assetRoot = catalogUrl.replace(/[^/]+$/, '');
        var popular = brands.filter(function (brand) {
          return brand.popular && brand.name;
        });

        if (popularList && popularWrap && popular.length) {
          popularList.innerHTML = popular
            .map(function (brand) {
              return (
                '<li><a href="' +
                escapeHtml(vendorUrl(brand)) +
                '">' +
                escapeHtml(brand.name) +
                '</a></li>'
              );
            })
            .join('');
          popularWrap.hidden = false;
        }

        if (loadingEl) loadingEl.remove();
        grid.insertAdjacentHTML(
          'beforeend',
          brands
            .filter(function (brand) {
              return brand.name && brand.source !== 'unoclean';
            })
            .map(function (brand) {
              return buildBrandCard(brand, assetRoot);
            })
            .join('')
        );

        bindInteractions();
      })
      .catch(function () {
        if (loadingEl) loadingEl.textContent = 'Unable to load brands. Please refresh the page.';
      });
  }

  function boot() {
    document.querySelectorAll('[data-tcb-brands-page]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-tcb-brands-page]');
    if (section) initSection(section);
  });
})();
